import { store, CHART_STATS_KEY } from '@/model/store';

const bundled = {
    files: [
        {
            id: 'Bundled',
            isFolder: true,
            files: [
                { id: 'Twinkle_Twinkle_Little_Star.mxl' },
                { id: 'Jingle_Bells.mxl' },
                { id: 'Chopsticks.mxl' },
                { id: 'Hark_the_Herald_Angels_Sing.mxl' },
                { id: 'Amazing_Grace_easy_piano.mxl' },
                { id: 'Take_Me_Out_To_The_Ball_Game.mxl' },
                { id: 'Minuet_in_G_Major_fixed.mxl' }
            ]
        },
        {
            id: 'Phase shift',
            isFolder: true,
            files: [
                // { id: 'call_me_maybe.mxl' },
                // { id: 'call_me_maybe-medium.mxl' }
            ]
        },
        // {
        //     id: 'still_dre.mid'
        // }
    ]
};

const demo = {
    files: [
        { id: 'Twinkle_Twinkle_Little_Star.mxl' },
        { id: 'Jingle_Bells.mxl' },
        { id: 'Chopsticks.mxl' },
        { id: 'Hark_the_Herald_Angels_Sing.mxl' },
        { id: 'Amazing_Grace_easy_piano.mxl' },
        { id: 'Take_Me_Out_To_The_Ball_Game.mxl' },
        { id: 'Minuet_in_G_Major_fixed.mxl' }
    ]
};
export function readChartsFolder() {
    let charStats = store.getItemOrCreateEmpty(CHART_STATS_KEY, []);
    const userSongs = (store.settings.files || [])
    .filter(f => (f.includes('.mxl') || f.includes('.mid')) && !f.includes('metadata'))
    .map(filePath => ({
        id: filePath.substring(filePath.lastIndexOf('/') + 1),
        path: filePath.substring(filePath.lastIndexOf('/') + 1),
        isFolder: false
    }));
    let allSongs = {
        ...bundled,
    };
    return allSongs.files;
}

export function readChartsFolderDemo() {
    let charStats = store.getItemOrCreateEmpty(CHART_STATS_KEY, []);
    const userSongs = (store.settings.files || [])
    .filter(f => (f.includes('.mxl') || f.includes('.mid')) && !f.includes('metadata'))
    .map(filePath => ({
        id: filePath.substring(filePath.lastIndexOf('/') + 1),
        path: filePath.substring(filePath.lastIndexOf('/') + 1),
        isFolder: false
    }));
    let allSongs = {
        ...demo,
    };
    allSongs.files.forEach((chart) => {
        if (!chart.isFolder) {
            const stats = charStats.find(s => s.id === chart.id) || { played: false, progress: 0 };
            Object.assign(chart, stats);
        } else {
            chart.files.forEach(file => {
                const stats = charStats.find(s => s.id === file.id) || { played: false, progress: 0 };
                Object.assign(file, stats);
            });
            if (!chart.files.find(f => f.id === '⮑ BACK')) {
                chart.files = [
                    {
                        id: '⮑ BACK',
                        isFolder: true
                    },
                    ...chart.files
                ]
            }
        }
    });
    return allSongs.files;
}